// ランキングバッジのエリア名(.stekina-media-ranking-badge-area)の文字数に応じて
// len-3 / len-5 / len-long クラスを付与し、CSS(_ranking_badge.scss)でフォント等を出し分ける。


const AREA_SELECTOR = '.stekina-media-ranking-badge-area';

// 1要素にlen-*クラスを付与
function applyLenToElement(el) {
  const len = [...el.textContent.trim()].length;
  el.classList.toggle('len-3', len <= 3);
  el.classList.toggle('len-5', len > 3 && len <= 5);
  el.classList.toggle('len-long', len > 5);
  el.style.display = 'block';
}

// root配下のバッジエリアすべてに適用(root自身が対象の場合も拾う)
function applyLenClass(root = document) {
  if (root.nodeType === Node.ELEMENT_NODE && root.matches && root.matches(AREA_SELECTOR)) {
    applyLenToElement(root);
  }
  if (root.querySelectorAll) {
    root.querySelectorAll(AREA_SELECTOR).forEach(applyLenToElement);
  }
}

function init() {
  // ① 初回(HTMLに最初からあるバッジ)
  applyLenClass(document);

  // ② 後から差し込まれるバッジ(render_async / もっと見る 等)
  //    追加されたノードのまとまりだけを処理するので、毎回の全体走査は発生しない。
  if (typeof MutationObserver !== 'undefined' && document.body) {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            applyLenClass(node);
          }
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

// Turbolinks / Turbo のページ遷移後にも初回適用(Observerは遷移先bodyに対し張り直し)
document.addEventListener('turbolinks:load', () => applyLenClass(document));
document.addEventListener('turbo:load', () => applyLenClass(document));

export { applyLenClass };
